import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
serviceWorkerRegistration.register();
reportWebVitals();
